namespace InvData {
    export class User {
        public id: number;
        public code: string;
        public fullName: string;
        public resourceId: number;
        public isLoginDisabled: boolean;

        constructor(userData: any) {
            this.id = userData.id ? userData.id : null;
            this.code = userData.code ? userData.code : null;
            this.fullName = userData.fullName ? userData.fullName : null;
            this.resourceId = userData.resourceId ? userData.resourceId: null;
            this.isLoginDisabled = userData.isLoginDisabled ? userData.isLoginDisabled : null; 
        }
    }
}

